module.exports = __webpack_public_path__ + "img/Trophy Cup Table32.d9fd23dc.jpg";